export default __webpack_public_path__ + "static/media/timeline-2.cd22573e.jpg";